export default function RegisteredUsersController() {}
